export var Shadows;
(function (Shadows) {
    Shadows["elevation5"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.1)";
    Shadows["elevation6"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.2)";
    Shadows["elevation10"] = "0px 20px 30px 0px rgba(0, 0, 0, 0.1)";
    Shadows["elevation20"] = "0px 10px 30px 0px rgba(0, 0, 0, 0.2)";
    Shadows["elevation30"] = "0px 10px 20px 0px rgba(0, 0, 0, 0.3)";
})(Shadows || (Shadows = {}));
//# sourceMappingURL=Shadows.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
